import React from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import OrdersContainer from "../../container/admin/orders";
import ShopOrdersView from "./ShopOrders";

// One Orders section: staff sales (field staff, payment links) and app orders (shop, GoSwift).
// The two are stored separately because they work differently; admins see them in one place.
const OrdersHub = () => {
    const [params, setParams] = useSearchParams();
    const tab = params.get("tab") === "app" ? "app" : "staff";

    return (
        <Box>
            <Tabs
                value={tab}
                onChange={(_, value) => setParams(value === "app" ? { tab: "app" } : {})}
                sx={{ mb: 2, borderBottom: 1, borderColor: "divider" }}
            >
                <Tab value="staff" label="Staff sales" />
                <Tab value="app" label="App orders" />
            </Tabs>
            {tab === "app" ? <ShopOrdersView /> : <OrdersContainer />}
        </Box>
    );
};

export default OrdersHub;
